<template>
  <v-container class="contenedor">
    <v-row justify="center">
      <v-col sm="12" md="12" lg="12" dense>
        <childProductDetail
          :updateShopingQuantity="updateShopingQuantity"
          :similarProducts="similarProducts"
          :showSimilar="showSimilar"
          :product="product"
          :sendSnack="sendSnack"
        >
        </childProductDetail>
      </v-col>
    </v-row>

    <v-row>
      <v-col sm="8" md="7" lg="8">
        <div v-show="showRelated">
          <h1 class="pa-4 primary--text">Complementos Técnicos</h1>
          <childRelated
            :products="relatedProducts"
            :similar="false"
            :sendSnack="sendSnack"
          >
          </childRelated>
        </div>

        <div>
          <childProductCharacteristic
            :productoCaracteristicas="product.characteristicValues.slice(0, 5)"
            :sendSnack="sendSnack"
          >
          </childProductCharacteristic>
        </div>

        <div>
          <childProductCharacteristic2
            v-if="product.characteristicValues.length > 5"
            :productoCaracteristicas2="
              product.characteristicValues.slice(
                5,
                product.characteristicValues.length
              )
            "
            :sendSnack="sendSnack"
          >
          </childProductCharacteristic2>
        </div>

        <div>
          <h1 class="pa-4 primary--text">Productos Relacionados</h1>

          <childRelated
            :products="otherProducts"
            :similar="false"
            :sendSnack="sendSnack"
          >
          </childRelated>
        </div>
      </v-col>

      <v-col sm="4" md="5" lg="4">
        <div>
          <childProductDetailBaner :sendSnack="sendSnack">
          </childProductDetailBaner>
        </div>

        <div>
          <childProductDetailBaner2
            class="caracteristicas"
            :sendSnack="sendSnack"
          >
          </childProductDetailBaner2>
        </div>

        <div>
          <childProductDetailBaner3
            class="caracteristicas"
            :sendSnack="sendSnack"
          >
          </childProductDetailBaner3>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import childProductDetail from "./child_productDetails.vue";
import childRelated from "./child_relatedProducts.vue";
import childSimilar from "./child_similarProducts.vue";
import childProductCharacteristic from "./child_productDetail_Characteristic.vue";
import childProductCharacteristic2 from "./child_productDetail_Characteristic2.vue";
import childProductDetailBaner from "./child_productDetail_baner.vue";
import childProductDetailBaner2 from "./child_productDetail_baner2.vue";
import childProductDetailBaner3 from "./child_productDetail_baner3.vue";

export default {
  name: "productDetail",

  components: {
    childProductDetail,
    childRelated,
    childSimilar,
    childProductCharacteristic,
    childProductCharacteristic2,
    childProductDetailBaner,
    childProductDetailBaner2,
    childProductDetailBaner3,
  },

  data() {
    return {
      product: {},
      showRelated: false,
      relatedProducts: [],
      similarProducts: [],
      otherProducts: [],
      showSimilar: false,
    };
  },

  props: {
    sendSnack: { type: Function },
    updateShopingQuantity: { type: Function },
  },

  methods: {
    getProductBySKU: async function ({ sku }) {
      const vm = this;
      const PRODUCT = await this.$http.get(`product/sku/${sku}`).then(
        async (response) => response.body.data,
        (error) => console.log(error.message || "Error al obtener producto")
      );

      vm.product = PRODUCT;

      let { related, similar } = await this.$http
        .get(`relatedProduct/product/${PRODUCT.id}`)
        .then(async (relatedProducts) => {
          var products = relatedProducts.body.data;
          let related = [];
          let similar = [];
          products.map((product) => {
            if (product.type == "similar") {
              product.relatedItem.comments = product.comment;
              product.relatedItem.similar = true;
              similar.push(product.relatedItem);
            } else {
              product.relatedItem.comments = product.comment;
              product.relatedItem.related = true;
              related.push(product.relatedItem);
            }
          });
          return { related, similar };
        });

      let otherItems = await this.$http
        .get(
          `product/byTypeName/${this.product.productTypeId}/${this.product.commonName}`
        )
        .then(async (type) => type.body.data);

      if (otherItems.length < 21) {
        let other = await vm.$http
          .get(`product/byName/${this.product.commonName}`)
          .then(async (items) => items.body.data);
        otherItems = [...otherItems, ...other];
      }
      vm.showRelated = related.length > 0 ? true : false;
      vm.showSimilar = similar.length > 0 ? true : false;
      vm.relatedProducts = related;
      vm.similarProducts = similar;
      vm.otherProducts = otherItems;
    },
  },

  computed: {},

  watch: {},

  created() {
    this.getProductBySKU(this.$route.params);
  },

  mounted() {
    window.scrollTo(0, 0);
  },
};
</script>

<style scoped>
#app {
  display: flex;
  height: 100%;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  background: rgba(245, 243, 243, 0.952);
}

.contenedor {
  background: white;
  height: auto;
  min-height: 990px;
}

.return-link {
  font-size: 1.4rem;
}

.information {
  justify-content: center;
  align-items: center;
  margin-top: -30px;
}

.caracteristicas {
  margin-top: 20px;
}
</style>
